import axios, { type AxiosInstance } from "axios";
import { apiBaseUrl } from "../auth/authConfig";

/**
 * Build an axios client with the Cognito id_token attached as a Bearer
 * header. Caller passes the token in; we keep this stateless so it
 * survives React Strict-Mode double-mounts cleanly.
 */
export function makeApiClient(idToken: string | undefined): AxiosInstance {
  const instance = axios.create({
    baseURL: apiBaseUrl(),
    timeout: 15_000,
  });
  if (idToken) {
    instance.defaults.headers.common["Authorization"] = `Bearer ${idToken}`;
  }
  return instance;
}

export interface RecentWork {
  work_id: string;
  title: string;
  creator: string;
  created_at: string | null;
}

export interface PayloadEntry {
  evidence_id: string;
  received_at: string | null;
  supporting_data: unknown;
}

export interface WorkPayloadsResponse {
  work_id: string;
  next_since: string;
  payloads: PayloadEntry[];
}

export async function getRecentWorks(client: AxiosInstance): Promise<RecentWork[]> {
  const { data } = await client.get<{ works: RecentWork[] }>("/daw/admin/works/recent");
  return data.works;
}

export async function getWorkPayloads(
  client: AxiosInstance,
  workId: string,
  since: string | undefined,
): Promise<WorkPayloadsResponse> {
  const { data } = await client.get<WorkPayloadsResponse>(
    `/daw/admin/works/${workId}/payloads`,
    { params: since ? { since } : undefined },
  );
  return data;
}
